<div class="item-list">
  <div class="title-section">
    <div class="subtitle-03">
      {{ selectedClassLabel$ | async }} #{{ focusedObjectIndex$ | async }}
    </div>
    <button mat-icon-button (click)="close('button')">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>

  <mat-form-field class="search-input" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <mat-icon matPrefix class="search-icon">search</mat-icon>
    <input
      matInput
      type="search"
      #filterInput
      [(ngModel)]="classFilter"
      (ngModelChange)="filterClasses()"
      (focusin)="onSearchFocusIn()"
      (focusout)="onSearchFocusOut()"
      (keydown.enter)="onSearchKeyDownEnter($event)"
    />
  </mat-form-field>

  <h3-top-five-classes
    (selectClass)="updateClassAndClose($event)"
  ></h3-top-five-classes>

  <mat-tree
    #tree
    [childrenAccessor]="childrenAccessor"
    [dataSource]="dataSource$ | async"
  >
    <mat-tree-node
      *matTreeNodeDef="let node"
      matTreeNodePadding
      matTreeNodePaddingIndent="16"
      (click)="updateClassAndClose(node.name)"
      [class.is-selected]="node.isSelected"
      [class.is-highlighted]="
        (isSearchFocused$ | async) && node.id === (highlightedClassId$ | async)
      "
      [style.border-color]="node.color"
      class="class-item body-01"
    >
      <div>
        <span class="class-label"> {{ node.label }}</span>
      </div>
    </mat-tree-node>

    <mat-tree-node
      *matTreeNodeDef="let node; when: isGroupTaxonomy"
      matTreeNodePadding
      matTreeNodePaddingIndent="16"
      class="class-item body-01"
      [class.is-selected]="node.isSelected"
      isExpandable
    >
      <div
        class="mat-tree-node"
        matTreeNodeToggle
        (click)="onGroupNodeExpanded(node)"
      >
        <span class="class-label" [class.first-node]="!node.level">
          {{ node.label }}</span
        >
        <mat-icon>
          {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </div>
    </mat-tree-node>
  </mat-tree>
</div>
